import { Type, type Static } from '@sinclair/typebox';
import { ListResponseSchema } from '../../shared/utils/list-response.schema';
import { CalendarEventSchema } from './calendar-event.schema';

export const GetCalendarEventListResponseSchema = ListResponseSchema(CalendarEventSchema);

export const GetCalendarEventResponseSchema = CalendarEventSchema;

export const CreateCalendarEventResponseSchema = CalendarEventSchema;

export const UpdateCalendarEventResponseSchema = CalendarEventSchema;

export const DeleteCalendarEventResponseSchema = Type.Null();

export const SetCalendarEventRsvpResponseSchema = Type.Null();

export const CancelCalendarEventResponseSchema = Type.Null();

export const RestoreCalendarEventResponseSchema = Type.Null();

export type GetCalendarEventListResponse = Static<typeof GetCalendarEventListResponseSchema>;
export type GetCalendarEventResponse = Static<typeof GetCalendarEventResponseSchema>;
export type CreateCalendarEventResponse = Static<typeof CreateCalendarEventResponseSchema>;
export type UpdateCalendarEventResponse = Static<typeof UpdateCalendarEventResponseSchema>;
export type DeleteCalendarEventResponse = Static<typeof DeleteCalendarEventResponseSchema>;
export type SetCalendarEventRsvpResponse = Static<typeof SetCalendarEventRsvpResponseSchema>;
export type CancelCalendarEventResponse = Static<typeof CancelCalendarEventResponseSchema>;
export type RestoreCalendarEventResponse = Static<typeof RestoreCalendarEventResponseSchema>;
